"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.identifyOnSubmit = exports.useIdentifyOnSubmit = exports.identifyUserCompanyTeam = exports.identifyUserCompany = exports.identifyProfile = exports.identifySegment = exports.usePreparedTracker = exports.useTracker = exports.useOldTracker = void 0;
// customer io cio customerio events
var end2end_1 = require("@hudled/end2end");
var firestore_1 = require("firebase/firestore");
var mapKeys_1 = __importDefault(require("lodash/mapKeys"));
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var react_redux_1 = require("react-redux");
var backend_1 = require("utils/backend");
var processData_1 = require("utils/firebase/processData");
var segment_1 = require("utils/segment");
var firestore_2 = require("./firebase/firestore");
var logging_1 = require("./logging");
var single_1 = require("./selectors/single");
var valueTranslator_1 = __importDefault(require("./tracking/valueTranslator"));
var backEndEvents = [
    'User Account Creation Initiated',
    'User Account Created',
    'Pricing insights Unlocked',
    'Quote Submitted',
    'OAuth Completed',
];
var getAnonymousId = function () {
    try {
        return JSON.parse(localStorage.getItem('ajs_anonymous_id') || '');
    }
    catch (_a) {
        return undefined;
    }
};
var getLocalUserId = function () {
    try {
        return JSON.parse(localStorage.getItem('ajs_user_id') || '');
    }
    catch (_a) {
        return undefined;
    }
};
var useOldTracker = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    return function (event, properties) {
        var processedProperties = (0, mapValues_1.default)(properties, function (v, k) { var _a, _b; return ((_b = (_a = valueTranslator_1.default[event]) === null || _a === void 0 ? void 0 : _a[k]) === null || _b === void 0 ? void 0 : _b[v]) || v; });
        var analyticsDataProperties = __assign(__assign({}, processedProperties), { fromRecharglySite: end2end_1.IS_RECHARGLY || undefined, group__company: profile.companyId, group__companyTeam: profile.companyTeamId });
        window.analytics.track(event, analyticsDataProperties, { context: { groupId: "company-".concat(profile.companyId) } });
        if (backEndEvents.includes(event)) {
            (0, backend_1.callBackendFn)('analytics-backendTrackEvent', {
                event: event,
                anonymousId: getAnonymousId(),
                userId: getLocalUserId(),
                properties: __assign(__assign({}, analyticsDataProperties), { userAgent: navigator.userAgent }),
            });
        }
    };
};
exports.useOldTracker = useOldTracker;
var useTracker = function () { return ((0, exports.useOldTracker)()); };
exports.useTracker = useTracker;
var usePreparedTracker = function (eventName, fixedValues) {
    var tracker = (0, exports.useTracker)();
    return function (properties) {
        if (!eventName) {
            (0, logging_1.logError)('Trying to use step tracker without specifying `eventName`');
            return;
        }
        try {
            tracker(eventName, __assign(__assign({}, fixedValues), properties));
        }
        catch (err) {
            (0, logging_1.logError)('Error firing track event');
        }
    };
};
exports.usePreparedTracker = usePreparedTracker;
var identifySegment = function (user) { return __awaiter(void 0, void 0, void 0, function () {
    var uid, displayName, email, providerData, metadata, baseData, profileRef, profileDoc, profile, companyId, companyRef, companyTeamId, companyTeamRef;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!user) {
                    return [2 /*return*/];
                }
                uid = user.uid, displayName = user.displayName, email = user.email, providerData = user.providerData, metadata = user.metadata;
                baseData = {
                    'auth.displayName': displayName,
                    'auth.email': email,
                    authProvider: (_a = providerData[0]) === null || _a === void 0 ? void 0 : _a.providerId,
                    realsource: window.location.search || 'N/A',
                    createdAt: metadata.creationTime,
                    fromHudled: !end2end_1.IS_RECHARGLY,
                    hudledAuth: !end2end_1.IS_RECHARGLY,
                };
                window.analytics.identify(uid, baseData);
                profileRef = (0, firestore_2.makeDocRef)('users', uid);
                return [4 /*yield*/, (0, firestore_1.getDoc)(profileRef)];
            case 1:
                profileDoc = _b.sent();
                if (!profileDoc.exists() || !profileDoc.get('companyId')) {
                    return [2 /*return*/];
                }
                profile = (0, processData_1.extractDocWithId)(profileDoc);
                if (!profile)
                    return [2 /*return*/];
                (0, exports.identifyProfile)(profileRef);
                companyId = profile.companyId;
                if (companyId) {
                    companyRef = (0, firestore_2.makeDocRef)('companies', companyId);
                    (0, exports.identifyUserCompany)(uid, companyRef);
                }
                companyTeamId = profile.companyTeamId;
                if (companyTeamId) {
                    companyTeamRef = (0, firestore_2.makeDocRef)('company_teams', companyTeamId);
                    (0, exports.identifyUserCompanyTeam)(uid, companyTeamRef);
                }
                return [2 /*return*/];
        }
    });
}); };
exports.identifySegment = identifySegment;
var identifyProfile = function (profileRef) { return __awaiter(void 0, void 0, void 0, function () {
    var profileSnap, profile, withProfileData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log('HERE getDoc(profileRef)');
                return [4 /*yield*/, (0, firestore_1.getDoc)(profileRef)];
            case 1:
                profileSnap = _a.sent();
                console.log('HERE getDoc(profileRef) after');
                profile = (0, processData_1.extractDocWithId)(profileSnap);
                if (!profile)
                    return [2 /*return*/];
                withProfileData = (0, end2end_1.cleanFbData)(profile);
                withProfileData.name = profile.displayName;
                withProfileData.avatar = profile.avatarUrl;
                window.analytics.identify(profile.id, withProfileData);
                return [2 /*return*/];
        }
    });
}); };
exports.identifyProfile = identifyProfile;
var identifyUserCompany = function (uid, companyRef) { return __awaiter(void 0, void 0, void 0, function () {
    var companySnap, company, companyClean;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log('HERE getDoc(companyRef)');
                return [4 /*yield*/, (0, firestore_1.getDoc)(companyRef)];
            case 1:
                companySnap = _a.sent();
                console.log('HERE getDoc(companyRef) after');
                company = (0, processData_1.extractDocWithId)(companySnap);
                if (!company)
                    return [2 /*return*/];
                companyClean = (0, end2end_1.cleanFbData)(company);
                window.analytics.identify(uid, (0, mapKeys_1.default)(companyClean, function (v, k) { return "company.".concat(k); }));
                window.analytics.group("company-".concat(company.id), __assign(__assign({}, company), { groupType: 'company', groupValue: company.id, group__company: company.id }));
                return [2 /*return*/];
        }
    });
}); };
exports.identifyUserCompany = identifyUserCompany;
var identifyUserCompanyTeam = function (uid, companyTeamRef) { return __awaiter(void 0, void 0, void 0, function () {
    var companyTeamSnap, e_1, companyTeam, companyTeamClean;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log('HERE getDoc(companyTeamRef)');
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, firestore_1.getDoc)(companyTeamRef)];
            case 2:
                companyTeamSnap = _a.sent();
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                (0, logging_1.logError)("Can't load team ".concat(companyTeamRef.id), e_1);
                return [2 /*return*/];
            case 4:
                console.log('HERE getDoc(companyTeamRef) after');
                if (!companyTeamSnap.exists) {
                    (0, logging_1.logError)("User ".concat(uid, " pointing to non existing team ").concat(companyTeamRef.id));
                    return [2 /*return*/];
                }
                companyTeam = (0, processData_1.extractDocWithId)(companyTeamSnap);
                if (!companyTeam)
                    return [2 /*return*/];
                companyTeamClean = (0, end2end_1.cleanFbData)(companyTeam);
                window.analytics.identify(uid, (0, mapKeys_1.default)(companyTeamClean, function (v, k) { return "companyTeam.".concat(k); }));
                window.analytics.group("team-".concat(companyTeam.id), __assign(__assign({}, companyTeamClean), { groupType: 'companyTeam', groupValue: companyTeam.id, group__companyTeam: companyTeam.id }));
                return [2 /*return*/];
        }
    });
}); };
exports.identifyUserCompanyTeam = identifyUserCompanyTeam;
var useIdentifyOnSubmit = function (collection) {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    return function (docRef) { return (0, exports.identifyOnSubmit)(profile, collection, docRef); };
};
exports.useIdentifyOnSubmit = useIdentifyOnSubmit;
var identifyOnSubmit = function (profile, collection, docRef) {
    switch (collection) {
        case 'companies':
            if (profile.companyId === docRef.id) {
                (0, exports.identifyUserCompany)(profile.id, docRef);
            }
            break;
        case 'company_teams':
            if (profile.companyTeamId === docRef.id) {
                (0, exports.identifyUserCompanyTeam)(profile.id, docRef);
            }
            break;
        case 'users':
            if (profile.id === docRef.id) {
                (0, exports.identifyProfile)(docRef);
            }
            break;
        default:
            break;
    }
};
exports.identifyOnSubmit = identifyOnSubmit;
exports.default = segment_1.loadSegment;
